import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  userActivityConversationsData: any;
  userActivityConversationsLoading: boolean;
  userActivityConversationsError: SerializedError | null;
} = {
  userActivityConversationsData: null,
  userActivityConversationsLoading: false,
  userActivityConversationsError: null,
};

export const userActivityConversationsFunc = createAsyncThunk(
  'userActivityConversations/userActivityConversationsFunc',
  async () => {
    const accessTokenJSON = localStorage.getItem('auth');
    const data1 = JSON.stringify({
      query: `query UserActivityConversations {
      user_activityConversations {
        count
        data {
          activity {
            activityId {
              _id
            }
            coverImage
            createdBy {
              _id
            }
            exteriorOrganizer {
              _id
              contact {
                phoneNumber
              }
              createdAt
              details
              imageUrl
              name
              updatedAt
            }
            title
          }
          lastMessage {
            _id
            activity {
              _id
            }
            attachments
            content
            createdAt
            receiver {
              _id
            }
            receiverHasRead
            receiverHasReceived
            sender {
              _id
            }
            senderHasSend
            updatedAt
          }
          receiver {
            _id
            description
            displayImageUrl
            displayName
            role
          }
        }
      }
    }`,
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const userActivityConversations = createSlice({
  name: 'userActivityConversations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userActivityConversationsFunc.pending, (state) => {
      state.userActivityConversationsLoading = true;
    });
    builder.addCase(userActivityConversationsFunc.fulfilled, (state, action) => {
      state.userActivityConversationsLoading = false;
      state.userActivityConversationsData = action.payload.data.user_activityConversations;
      state.userActivityConversationsError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userActivityConversationsFunc.rejected, (state, action) => {
      state.userActivityConversationsLoading = false;
      state.userActivityConversationsError = action.error ?? null;
    });
  },
});

export default userActivityConversations.reducer;
